
















import { QuestionSubjective } from '@/resource/question/question.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SubjectiveParent from '@/components/questions/subjective-components/SubjectiveParent.vue';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import {
  getMainLanguage,
  getHtmlByLanguages,
} from '@/components/question-editor/question-editor-util';

@Component({
  components: {
    SubjectiveParent,
  },
})
export default class QuestionSubjectiveContainer extends Vue {
  @Prop({ required: true })
  question!: QuestionSubjective;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  @Prop({ default: false })
  isWithoutAnswer!: boolean;

  questionHtml = '';

  getQuestionHtml() {
    if (this.question.questionHtmls) {
      this.questionHtml = getHtmlByLanguages(
        this.isWithoutAnswer && this.question.pdfHtmls
          ? this.question.pdfHtmls
          : this.question.questionHtmls,
        this.languages,
      );
    }
  }

  created() {
    this.getQuestionHtml();
  }

  get mainLanguage() {
    return getMainLanguage(this.languages);
  }
}
